import React from "react";

import VirtualInstallationImage from "src/assets/images/cgm/connection-journey/virtual-installation.webp";
import SelfInstallationImage from "src/assets/images/cgm/connection-journey/self-installation.webp";

import BottomSheet from "src/components/app/BottomSheet";
import Button from "src/components/app/Button";

type Props = {
  show: boolean;
  onClose: () => void;
  onSelectSelf: () => void;
  onSelectVirtual: () => void;
};

const CGMSelectConnectionMethodBottomSheet: React.FC<Props> = ({
  show,
  onClose,
  onSelectSelf,
  onSelectVirtual,
}) => {
  const connectionMethods = [
    {
      id: "virtual",
      title: "Virtual Installation",
      description: "Our experts will help you in installing your CGM",
      image: VirtualInstallationImage,
      buttonText: "Book Your Session",
      buttonOnClick: onSelectVirtual,
      variant: "contained",
    },
    {
      id: "self",
      title: "Self Installation",
      description:
        "Apply the CGM sensor on your own by following the step-by-step guide.",
      image: SelfInstallationImage,
      buttonText: "Start Connection Journey",
      buttonOnClick: onSelectSelf,
      variant: "outlined",
    },
  ];

  return (
    <BottomSheet
      show={show}
      handleClose={onClose}
      zIndex={60}
      fullScreen={true}
      showCloseButton={true}
    >
      <div className="pt-[32px]">
        <div className="border-b border-gray-200 pb-4" />
        <div className="p-4">
          <h2 className="text-xl font-semibold mb-1">
            Select your connection method
          </h2>
          <p className="text-[var(--text-secondary)] mb-5">
            Choose how you’d like to install and connect your CGM.
          </p>

          <div className="space-y-4">
            {connectionMethods.map((method, index) => (
              <React.Fragment key={method.id}>
                <div className="bg-color-accent-indigo rounded-2xl p-4 border-[1px] border-[#C7D7FE] relative pb-5">
                  <div className="flex items-start gap-4">
                    <div className="flex-shrink-0 w-24 h-24 bg-[#D1DFFF] rounded-xl flex items-center justify-center overflow-hidden">
                      <img
                        src={method.image}
                        alt={method.title}
                        className="w-full h-full object-cover object-top"
                      />
                    </div>
                    <div className="flex-1 self-center">
                      <h3 className="tracking-[0.25px] font-poppins text-[20px] leading-[26px] text-left font-semibold text-text-primary mb-1">
                        {method.title}
                      </h3>
                      <p className="tracking-[0.25px] font-poppins text-sm text-left text-text-quaternary">
                        {method.description}
                      </p>
                    </div>
                  </div>

                  <div className="mt-4">
                    <Button
                      onClick={method.buttonOnClick}
                      variant={
                        method.variant as "contained" | "outlined" | "text"
                      }
                      rounded="full"
                      fullWidth
                    >
                      {method.buttonText}
                    </Button>
                  </div>
                </div>

                {index < connectionMethods.length - 1 && (
                  <div className="flex items-center justify-center my-1 h-[1px] bg-[#E2E2EA]">
                    <span className="text-[#A2A2A8] text-[12px] px-2 bg-white">
                      or
                    </span>
                  </div>
                )}
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>
    </BottomSheet>
  );
};

export default CGMSelectConnectionMethodBottomSheet;
